import { render, staticRenderFns } from "./vsTrExpand.vue?vue&type=template&id=26524141&"
import script from "./vsTrExpand.vue?vue&type=script&lang=js&"
export * from "./vsTrExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsTrExpand.vue"
export default component.exports